import { Creditor } from '../Entity/Creditor';
import { PaymentTerm } from '../Payment/PaymentTerm';
import { CaseCreditorStatus } from '../Status/CaseCreditorStatus';
import { Case } from './Case';
import { CaseCreditorStatusChange } from './CaseCreditorStatusChange';
import { Product } from '../Product';

export class CaseCreditor {
  id?: number;
  case_id?: number;
  creditor_id?: number;
  recovery_creditor_id?: number;
  product_id?: number;
  type: 'secured' | 'unsecured' | 'claim';
  lender_type: 'collections' | 'standard' | 'high_interest';
  debt_type?: string;
  type_of_guarantee?: string;
  initial_balance?: number;
  current_balance?: number;
  monthly_payments?: number;
  tae?: number;
  restructured?: number;
  making_payments?: number;
  ownership?: string;
  additional_partner: any;
  reference_number?: string;
  judicial_claim?: string;
  verified?: number;
  notes?: string;
  proposal_location: string;
  proposal_location_accord: string;
  proposal_location_accord_partner: string;
  proposal_location_accord_both: string;
  drafting_status: string;
  total_repaid?: number;
  signature?: string;
  signature_partner?: string;
  viewed_by_client?: string;
  viewed_by_partner?: string;
  signed_by_client?: string;
  signed_by_partner?: string;
  contract_sent: boolean;
  client_ip?: string;
  partner_ip?: string;
  aep_sent: boolean | 0 | 1;
  amount_repaid?: number;
  client_documents_visible: boolean | 0 | 1;
  excluded: boolean | 0 | 1;
  debt_amount?: number;
  loan_id?: string;
  negotiated_amount?: number;
  total_reduction?: number;
  percent_reduction?: number;
  created_at?: Date | string;
  updated_at?: Date | string;
  case_creditor_status_id?: number;
  term?: number;
  amount_updated_at?: Date | string;
  negotiated_amount_updated_at?: Date | string;
  can_settle: boolean;

  // Relations
  recovery_creditor?: Creditor;
  creditor?: Creditor;
  product?: Product;
  case_creditor_status?: CaseCreditorStatus;
  case_creditor_status_changes?: CaseCreditorStatusChange;
  offer_to_creditor?: number;
  final_payment?: number;
  terms?: number;
  current_creditor_id?: number;
  last_paid?: Date | string;
  case?: Case;
  debt_plan_fees?: Array<PaymentTerm>;
  latest_case_creditor_status_log?: any;

  // Helpers
  active_debt?: number;
}

export class CaseCreditorPivot extends Creditor {
  pivot?: CaseCreditor;
}
